module.exports = __webpack_public_path__ + "media/images/home-page/3-6@2x-4af983c6ec67b41e4945434d9c2c0cda.png";